import { NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyrightInfoComponent } from './common/components/copyright-info/copyright-info.component';
import { AgmCoreModule } from '@agm/core';
import { materialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HammerGestureConfig, HammerModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import * as hammer from "hammerjs";
import { UserInfoComponent } from './common/components/user-info/user-info.component';
import { HeaderInfoComponent } from './common/components/header-info/header-info.component';
import { ConfirmationBoxComponent } from "./common/components/confirmation-box/confirmation-box.component";
import { AlertBoxComponent } from "../core/common/components/alert-box/alert-box.component";
import { InputBoxComponent } from "../core/common/components/input-box/input-box.component";
import { GoogleMapAddressComponent } from "./common/components/google-map-address/google-map-address.component";
import { InputAddressComponent } from "./common/components/input-address/input-address.component";
import { ImportPlanButtonComponent } from "./projects/manage-projects/project/import-plan-button/import-plan-button.component";
import { ItemsPriceComponent } from './projects/manage-projects/item-list/items-price/items-price.component';
import { ItemsQuantityComponent } from './projects/manage-projects/item-list/items-quantity/items-quantity.component';
import { SetMarginComponent } from "./common/components/set-margin/set-margin.component";
import { RoofPanelSelectBoxComponent } from './projects/roof-plan/roof-panel/roof-panel-select-box/roof-panel-select-box.component';
import { OwnPanelComponent } from './projects/roof-plan/roof-panel/roof-panel-select-box/own-panel/own-panel.component';
import { SenPanelComponent } from './projects/roof-plan/roof-panel/roof-panel-select-box/sen-panel/sen-panel.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SearchDelayDirective } from "./common/components/search-delay/search-delay.directive";
import { FormsModule } from '@angular/forms';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { NgxMaskModule, IConfig } from 'ngx-mask';
const maskConfig: Partial<IConfig> = {
  validation: false,
};
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS, ISlimScrollOptions } from 'ngx-slimscroll';
import { TreeviewModule } from 'ngx-treeview';
import { TruncateModule } from 'ng2-truncate';
import { ColorPickerModule } from 'ngx-color-picker';

// custom configuration Hammerjs
@Injectable()
export class HammerConfig extends HammerGestureConfig {
  overrides = <any>{
    swipe: { direction: hammer.DIRECTION_HORIZONTAL },
    'pinch': { enable: false },
    'rotate': { enable: false }
  }
}

@NgModule({
  declarations: [
    CopyrightInfoComponent,
    UserInfoComponent,
    HeaderInfoComponent,
    ConfirmationBoxComponent,
    AlertBoxComponent,
    InputBoxComponent,
    GoogleMapAddressComponent,
    InputAddressComponent,
    SetMarginComponent,
    ImportPlanButtonComponent,
    RoofPanelSelectBoxComponent,
    OwnPanelComponent,
    SenPanelComponent,
    ItemsPriceComponent,
    ItemsQuantityComponent,
    SearchDelayDirective
  ],
  imports: [
    CommonModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyA1_bwW9C1jOq67nJfmQVzXpW_dBXflcSQ",
      libraries: ["places", 'drawing', 'geometry']
    }),
    materialModule,
    FlexLayoutModule,
    NgbModule,
    HammerModule,
    NgSlimScrollModule,
    FormsModule,
    NgxSliderModule,
    ReactiveFormsModule,
    TreeviewModule.forRoot(),
    MaterialFileInputModule,
    TruncateModule,
    ColorPickerModule,
    NgxMaskModule.forRoot(maskConfig)
  ],
  providers: [
    {
      provide: SLIMSCROLL_DEFAULTS,
      useValue: {
        barWidth: '4',
        barBackground: '#5c6c8d',
        gridWidth: '4'
      } as ISlimScrollOptions
    },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: HammerConfig
    }
  ],
  exports: [
    CopyrightInfoComponent,
    UserInfoComponent,
    HeaderInfoComponent,
    ConfirmationBoxComponent,
    InputBoxComponent,
    GoogleMapAddressComponent,
    InputAddressComponent,
    SetMarginComponent,
    ImportPlanButtonComponent,
    ItemsPriceComponent,
    ItemsQuantityComponent,
    RoofPanelSelectBoxComponent,
    OwnPanelComponent,
    SenPanelComponent,
    CommonModule,
    AgmCoreModule,
    materialModule,
    FlexLayoutModule,
    ColorPickerModule,
    NgbModule,
    HammerModule,
    TruncateModule,
    ReactiveFormsModule,
    NgxSliderModule,
    SearchDelayDirective,
    NgSlimScrollModule,
    FormsModule,
    TreeviewModule,
    MaterialFileInputModule,
    NgxMaskModule
  ]
})
export class SharedModule { }
